import React from "react";
import newssImage1 from "../../images/newss-image1.jpg";
import newssImage2 from "../../images/newss-image2.jpg";
import newssImage3 from "../../images/newss-image3.jpg";
import { BsArrowRight } from "react-icons/bs";

const Section7 = () => {
  return (
    <div>
      <section className="news bg-light">
        <div className="container flow-content">
          <h2 className="section-heading">Blog</h2>

          <p className="news__para">
            Explore our blog for helpful advice, event trends, and creative
            ideas. From décor tips to planning guidance, we aim to support you
            in making every celebration smooth, stylish, and memorable—no matter
            the size or occasion.
          </p>

          <div className="news__list split">
            <div className="news__listItem">
              <button className="section-links">
                <img src={newssImage1} alt="" />
              </button>
              <button>
                <h4>Birthdays Decoration</h4>
              </button>
              <p>Lorem ipsum dolor sit amet</p>
              <button className="section-links">
                <span>Read More</span>
                <span className="arrow__icon">
                  <BsArrowRight />
                </span>
              </button>
            </div>
            <div className="news__listItem">
              <button>
                <img src={newssImage2} alt="" />
              </button>
              <button>
                <h4>Birthdays Decoration</h4>
              </button>
              <p>Lorem ipsum dolor sit amet</p>
              <button className="section-links">
                <span>Read More</span>
                <span className="arrow__icon">
                  <BsArrowRight />
                </span>
              </button>
            </div>
            <div className="news__listItem">
              <button>
                <img src={newssImage3} alt="" />
              </button>
              <button>
                <h4>Birthdays Decoration</h4>
              </button>
              <p>Lorem ipsum dolor sit amet</p>
              <button className="section-links">
                <span>Read More</span>
                <span className="arrow__icon">
                  <BsArrowRight />
                </span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Section7;
